import { render, staticRenderFns } from "./AtribuirModal.vue?vue&type=template&id=8dbeef58"
import script from "./AtribuirModal.vue?vue&type=script&lang=js"
export * from "./AtribuirModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports